













import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ModalSimplePopup from '@/components/ModalSimplePopup.vue';

@Component({
  components: {
    ModalSimplePopup
  }
})
export default class Modal extends Vue {
  private x: number = 0;
  private y: number = 0;

  @Prop({ type: Boolean, required: true })
  isOpen!: boolean;

  @Prop({ type: Number, default: 0 })
  headerHeight!: number;

  @Prop({ type: String, required: true })
  src!: string;

  private onLoad(event: Event): void {
    const image: HTMLImageElement = event.target as HTMLImageElement;
    const rect: DOMRect = image.getBoundingClientRect() as DOMRect;
    this.x = rect.x - 30;
    this.y = rect.y - 30 - this.headerHeight;
  }
}
